import { Link } from 'react-router-dom';

export default function PillarArticle() {
  return (
    <section id="guides" className="py-20 md:py-28 px-6 md:px-10 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20 items-center">
          <div className="flex-1">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-6">
              Pillar Content
            </span>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight mb-5">
              The Ultimate Superbuy
              <br />
              Spreadsheet Resource Hub
            </h2>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-[500px] mb-8">
              Everything you need to know about Superbuy Spreadsheet — from finding the best product links to mastering your shopping workflow. Our comprehensive guides help you shop smarter and faster.
            </p>
            <Link
              to="/article/superbuy-spreadsheet-complete-guide"
              className="inline-flex items-center gap-2 px-7 py-3 bg-primary-500 text-white text-sm font-semibold rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              Read Full Guide
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
            </Link>

            <Link
              to="/article/superbuy-spreadsheet-qc-guide"
              className="inline-flex items-center gap-2 px-7 py-3 bg-background-200/80 text-foreground-900 text-sm font-semibold rounded-full hover:bg-background-300/70 transition-all whitespace-nowrap cursor-pointer ml-3"
            >
              QC Guide
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
            </Link>

            <Link
              to="/article/superbuy-spreadsheet-shipping-guide"
              className="inline-flex items-center gap-2 px-7 py-3 bg-background-200/80 text-foreground-900 text-sm font-semibold rounded-full hover:bg-background-300/70 transition-all whitespace-nowrap cursor-pointer ml-3"
            >
              Shipping Guide
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
            </Link>
          </div>

          <div className="flex-1 w-full">
            <div className="bg-background-200/80 rounded-3xl p-8 md:p-10 relative overflow-hidden">
              <div className="absolute top-6 right-6 flex items-center gap-1">
                <div className="w-1.5 h-1.5 rounded-full bg-accent-400"></div>
                <div className="w-1.5 h-1.5 rounded-full bg-accent-400"></div>
                <div className="w-1.5 h-1.5 rounded-full bg-accent-400"></div>
              </div>

              <span className="inline-block px-3 py-1 rounded-full bg-accent-100/70 text-accent-700 text-[11px] font-semibold mb-8">
                Latest Guide
              </span>

              <blockquote className="font-heading text-xl md:text-2xl text-foreground-800 leading-relaxed mb-8 italic">
                &ldquo;A well-organized Superbuy Spreadsheet transforms chaotic shopping into a streamlined experience — saving hours of searching and helping you discover products you never knew existed.&rdquo;
              </blockquote>

              <div className="flex items-center justify-between pt-6 border-t border-background-300/60">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-accent-200 flex items-center justify-center overflow-hidden">
                    <i className="ri-user-line w-5 h-5 flex items-center justify-center text-accent-700"></i>
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-foreground-900">Superbuy Sheet Team</p>
                    <p className="text-xs text-foreground-500">Editorial Team</p>
                  </div>
                </div>
                <Link
                  to="/article/superbuy-spreadsheet-complete-guide"
                  className="inline-flex items-center gap-2 px-5 py-2.5 bg-accent-100/60 text-accent-700 text-xs font-semibold rounded-full hover:bg-accent-200/60 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Read Full Guide
                  <i className="ri-arrow-right-up-line w-3.5 h-3.5 flex items-center justify-center"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}